/* This file is generated by vega-design 2.0.71 */
/* eslint-disable */
/* tslint:disable */
// prettier-ignore
const Typography = {
  "v-font-h1": [
    "@apply v-font-inter",
    "font-size:42px",
    "font-weight:700",
    "line-height:50px",
    "letter-spacing:0.42px"
  ],
  "M:v-font-h1": [
    "@apply v-font-inter",
    "font-size:42px",
    "font-weight:700",
    "line-height:50px",
    "letter-spacing:2.52px"
  ],
  "L:v-font-h1": [
    "@apply v-font-inter",
    "font-size:48px",
    "font-weight:700",
    "line-height:56px",
    "letter-spacing:0.96px"
  ],
  "XL:v-font-h1": [
    "@apply v-font-inter",
    "font-size:60px",
    "font-weight:700",
    "line-height:70px",
    "letter-spacing:1.8px"
  ],
  "v-font-h2": [
    "@apply v-font-inter",
    "font-size:32px",
    "font-weight:700",
    "line-height:40px",
    "letter-spacing:0px"
  ],
  "M:v-font-h2": [
    "@apply v-font-inter",
    "font-size:32px",
    "font-weight:700",
    "line-height:40px",
    "letter-spacing:0px"
  ],
  "L:v-font-h2": [
    "@apply v-font-inter",
    "font-size:36px",
    "font-weight:700",
    "line-height:44px",
    "letter-spacing:1.8px"
  ],
  "XL:v-font-h2": [
    "@apply v-font-inter",
    "font-size:42px",
    "font-weight:700",
    "line-height:52px",
    "letter-spacing:0.42px"
  ],
  "v-font-h3": [
    "@apply v-font-inter",
    "font-size:28px",
    "font-weight:500",
    "line-height:36px",
    "letter-spacing:0.28px"
  ],
  "M:v-font-h3": [
    "@apply v-font-inter",
    "font-size:28px",
    "font-weight:500",
    "line-height:36px",
    "letter-spacing:0.28px"
  ],
  "L:v-font-h3": [
    "@apply v-font-inter",
    "font-size:28px",
    "font-weight:500",
    "line-height:36px",
    "letter-spacing:0.28px"
  ],
  "XL:v-font-h3": [
    "@apply v-font-inter",
    "font-size:32px",
    "font-weight:500",
    "line-height:44px",
    "letter-spacing:0.32px"
  ],
  "v-font-h4": [
    "@apply v-font-inter",
    "font-size:24px",
    "font-weight:700",
    "line-height:32px",
    "letter-spacing:0px"
  ],
  "M:v-font-h4": [
    "@apply v-font-inter",
    "font-size:24px",
    "font-weight:700",
    "line-height:32px",
    "letter-spacing:0px"
  ],
  "L:v-font-h4": [
    "@apply v-font-inter",
    "font-size:24px",
    "font-weight:700",
    "line-height:32px",
    "letter-spacing:0px"
  ],
  "XL:v-font-h4": [
    "@apply v-font-inter",
    "font-size:28px",
    "font-weight:700",
    "line-height:36px",
    "letter-spacing:0px"
  ],
  "v-font-h5": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:28px",
    "letter-spacing:0px"
  ],
  "M:v-font-h5": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:28px",
    "letter-spacing:0px"
  ],
  "L:v-font-h5": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:28px",
    "letter-spacing:0px"
  ],
  "XL:v-font-h5": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:28px",
    "letter-spacing:0px"
  ],
  "v-font-h6": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:700",
    "line-height:25px",
    "letter-spacing:0px"
  ],
  "M:v-font-h6": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:700",
    "line-height:25px",
    "letter-spacing:0px"
  ],
  "L:v-font-h6": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:700",
    "line-height:25px",
    "letter-spacing:0px"
  ],
  "XL:v-font-h6": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:700",
    "line-height:25px",
    "letter-spacing:0px"
  ],
  "v-font-p1-short": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:500",
    "line-height:28px",
    "letter-spacing:0px"
  ],
  "M:v-font-p1-short": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:500",
    "line-height:27px",
    "letter-spacing:0px"
  ],
  "L:v-font-p1-short": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:500",
    "line-height:27px",
    "letter-spacing:0px"
  ],
  "XL:v-font-p1-short": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:500",
    "line-height:27px",
    "letter-spacing:0px"
  ],
  "v-font-p1-long": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:500",
    "line-height:32px",
    "letter-spacing:0px"
  ],
  "M:v-font-p1-long": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:500",
    "line-height:30px",
    "letter-spacing:0px"
  ],
  "L:v-font-p1-long": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:500",
    "line-height:30px",
    "letter-spacing:0px"
  ],
  "XL:v-font-p1-long": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:500",
    "line-height:30px",
    "letter-spacing:0px"
  ],
  "v-font-p2-short": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:500",
    "line-height:28px",
    "letter-spacing:0px"
  ],
  "M:v-font-p2-short": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "L:v-font-p2-short": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "XL:v-font-p2-short": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "v-font-p2-long": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:500",
    "line-height:30px",
    "letter-spacing:0px"
  ],
  "M:v-font-p2-long": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:28px",
    "letter-spacing:0px"
  ],
  "L:v-font-p2-long": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:28px",
    "letter-spacing:0px"
  ],
  "XL:v-font-p2-long": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:28px",
    "letter-spacing:0px"
  ],
  "v-font-btn-label": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "M:v-font-btn-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "L:v-font-btn-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "XL:v-font-btn-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "v-font-btn-label-lg": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "M:v-font-btn-label-lg": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "L:v-font-btn-label-lg": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "XL:v-font-btn-label-lg": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "v-font-btn-label-sm": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "M:v-font-btn-label-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:700",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "L:v-font-btn-label-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:700",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "XL:v-font-btn-label-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:700",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "v-font-btn-link-label": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "M:v-font-btn-link-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "L:v-font-btn-link-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "XL:v-font-btn-link-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "v-font-btn-link-label-lg": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "M:v-font-btn-link-label-lg": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:700",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "L:v-font-btn-link-label-lg": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:700",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "XL:v-font-btn-link-label-lg": [
    "@apply v-font-inter",
    "font-size:18px",
    "font-weight:700",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "v-font-btn-link-label-sm": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "M:v-font-btn-link-label-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:700",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "L:v-font-btn-link-label-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:700",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "XL:v-font-btn-link-label-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:700",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "v-font-field-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "M:v-font-field-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "L:v-font-field-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "XL:v-font-field-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "v-font-field-label-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:18px"
  ],
  "M:v-font-field-label-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:18px"
  ],
  "L:v-font-field-label-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:18px"
  ],
  "XL:v-font-field-label-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:18px"
  ],
  "v-font-field-label-xs": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:16px"
  ],
  "M:v-font-field-label-xs": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:16px"
  ],
  "L:v-font-field-label-xs": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:16px"
  ],
  "XL:v-font-field-label-xs": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:16px"
  ],
  "v-font-field-label-lg": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:500",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "M:v-font-field-label-lg": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:500",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "L:v-font-field-label-lg": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:500",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "XL:v-font-field-label-lg": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:500",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "v-font-field-label-em": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px"
  ],
  "M:v-font-field-label-em": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px"
  ],
  "L:v-font-field-label-em": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px"
  ],
  "XL:v-font-field-label-em": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px"
  ],
  "v-font-field-label-sm-em": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:700",
    "line-height:18px"
  ],
  "M:v-font-field-label-sm-em": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:700",
    "line-height:18px"
  ],
  "L:v-font-field-label-sm-em": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:700",
    "line-height:18px"
  ],
  "XL:v-font-field-label-sm-em": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:700",
    "line-height:18px"
  ],
  "v-font-field-label-xs-em": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:700",
    "line-height:16px",
    "letter-spacing:0px"
  ],
  "M:v-font-field-label-xs-em": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:700",
    "line-height:16px",
    "letter-spacing:0px"
  ],
  "L:v-font-field-label-xs-em": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:700",
    "line-height:16px",
    "letter-spacing:0px"
  ],
  "XL:v-font-field-label-xs-em": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:700",
    "line-height:16px",
    "letter-spacing:0px"
  ],
  "v-font-field-label-lg-em": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "M:v-font-field-label-lg-em": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "L:v-font-field-label-lg-em": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "XL:v-font-field-label-lg-em": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "v-font-field-value": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:400",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "M:v-font-field-value": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:400",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "L:v-font-field-value": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:400",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "XL:v-font-field-value": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:400",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "v-font-field-value-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:16px"
  ],
  "M:v-font-field-value-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:16px"
  ],
  "L:v-font-field-value-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:16px"
  ],
  "XL:v-font-field-value-sm": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:16px"
  ],
  "v-font-field-value-em": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "M:v-font-field-value-em": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "L:v-font-field-value-em": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "XL:v-font-field-value-em": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:22px",
    "letter-spacing:0px"
  ],
  "v-font-field-value-disabled": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:400",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "M:v-font-field-value-disabled": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:400",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "L:v-font-field-value-disabled": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:400",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "XL:v-font-field-value-disabled": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:400",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "v-font-sidebar-link": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "M:v-font-sidebar-link": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "L:v-font-sidebar-link": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "XL:v-font-sidebar-link": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:500",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "v-font-sidebar-link-em": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "M:v-font-sidebar-link-em": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "L:v-font-sidebar-link-em": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "XL:v-font-sidebar-link-em": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px",
    "letter-spacing:0px"
  ],
  "v-font-footnote1-short": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "M:v-font-footnote1-short": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "L:v-font-footnote1-short": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "XL:v-font-footnote1-short": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "v-font-footnote1-long": [
    "@apply v-font-inter",
    "font-size:14px",
    "font-weight:400",
    "line-height:20px",
    "letter-spacing:0px"
  ],
  "M:v-font-footnote1-long": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "L:v-font-footnote1-long": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "XL:v-font-footnote1-long": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "v-font-footnote2-short": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:16px",
    "letter-spacing:0px"
  ],
  "M:v-font-footnote2-short": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:16px",
    "letter-spacing:0px"
  ],
  "L:v-font-footnote2-short": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:16px",
    "letter-spacing:0px"
  ],
  "XL:v-font-footnote2-short": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:16px",
    "letter-spacing:0px"
  ],
  "v-font-footnote2-long": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:20px",
    "letter-spacing:0px"
  ],
  "M:v-font-footnote2-long": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "L:v-font-footnote2-long": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "XL:v-font-footnote2-long": [
    "@apply v-font-inter",
    "font-size:12px",
    "font-weight:400",
    "line-height:18px",
    "letter-spacing:0px"
  ],
  "v-font-h-modal": [
    "@apply v-font-inter",
    "font-size:24px",
    "font-weight:700",
    "line-height:32px"
  ],
  "M:v-font-h-modal": [
    "@apply v-font-inter",
    "font-size:24px",
    "font-weight:700",
    "line-height:32px"
  ],
  "L:v-font-h-modal": [
    "@apply v-font-inter",
    "font-size:24px",
    "font-weight:700",
    "line-height:32px"
  ],
  "XL:v-font-h-modal": [
    "@apply v-font-inter",
    "font-size:24px",
    "font-weight:700",
    "line-height:32px"
  ],
  "v-font-keypad-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px"
  ],
  "M:v-font-keypad-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px"
  ],
  "L:v-font-keypad-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px"
  ],
  "XL:v-font-keypad-label": [
    "@apply v-font-inter",
    "font-size:16px",
    "font-weight:700",
    "line-height:24px"
  ],
  "v-font-keypad-label-large": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:24px"
  ],
  "M:v-font-keypad-label-large": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:24px"
  ],
  "L:v-font-keypad-label-large": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:24px"
  ],
  "XL:v-font-keypad-label-large": [
    "@apply v-font-inter",
    "font-size:20px",
    "font-weight:700",
    "line-height:24px"
  ]
};

export { Typography as T };
